import { NextStepCardProps } from './NextStepCard/nextStepCard.types';

export const getItems: (
  isCareOnlyPPType: boolean,
  medication: string,
  isQualified?: boolean
) => NextStepCardProps[] = (
  isCareOnlyPPType: boolean,
  medication: string,
  isQualified?: boolean
) => {
  return [
    ...(isQualified
      ? [
          {
            description: 'Custom compound eligibility',
            isCompleted: true,
            title: 'Prequalified for custom semaglutide compound.'
          }
        ]
      : [
          { description: `${medication} – cash pay`, isCompleted: true, title: 'Choose medication' }
        ]),
    ...(!isCareOnlyPPType
      ? [
          {
            description:
              'You’ll move to a care-only plan, and you’ll pay the pharmacy directly for the medication.',
            isActive: true,
            showPlanInfo: true,
            title: 'Change plan (we’ll do this now)'
          }
        ]
      : []),
    {
      description:
        'When it’s time to renew your medication, your provider will review and prescribe your new medication.',
      isActive: isCareOnlyPPType,
      title: 'Your next renewal'
    },
    {
      description: 'You’ll complete payment online through our trusted pharmacy partner',
      isUpdated: true,
      title: 'Pay pharmacy for medication'
    },
    {
      description: 'Your medication will be delivered straight to your door—fast and hassle-free.',
      title: 'Medication shipped to your door'
    }
  ];
};
